import { render, staticRenderFns } from "./picUploadVideo.vue?vue&type=template&id=03f28be8&scoped=true&"
import script from "./picUploadVideo.vue?vue&type=script&lang=js&"
export * from "./picUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./picUploadVideo.vue?vue&type=style&index=0&id=03f28be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f28be8",
  null
  
)

export default component.exports